<template>
  <v-container fluid class="pa-0">
    <!-- Hero Section -->
    <v-img src="@/assets/images/tobias_run_side_low.jpg" class="hero-image">
      <v-sheet class="hero-overlay d-flex justify-center align-center">
        <h1 class="display-2 white--text text-center">Bem-vindo à T4 Sports</h1>
      </v-sheet>
    </v-img>

    <!-- About Section -->
    <v-container class="text-center py-12">
      <h3 class="subtitle">A T4 Sports é uma equipe de treinamento nas modalidades:</h3>
      <p class="body-1">Corrida - Natação no mar - Ciclismo - Triathlon - Treinamento funcional</p>

      <h4 class="headline mb-5">O que fazemos?</h4>
      <v-row class="d-flex justify-center">
        <!-- Service Cards -->
        <v-col cols="12" md="6" lg="4" v-for="(service, index) in services" :key="index">
          <v-card class="elevation-2 hover-card" flat>
            <v-img :src="service.image"></v-img>
            <v-card-text>
              <strong>{{ service.title }}:</strong> {{ service.description }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Schedule Section -->
    <v-container class="text-center py-12">
      <h4 class="headline">Horários de Treinamento Coletivo</h4>
      <v-row justify="center">
        <v-col cols="12" md="8">
          <p><strong>Enseada de Botafogo:</strong> Corrida - Ciclismo (rolo) - Circuito na areia - Treinamento funcional</p>
          <p>3° a 6° feira - 06:00hs - 09:00hs / Sábados - 07:30hs - 10:30hs</p>
          <p><strong>Praia de Copacabana:</strong> Natação no mar - corrida / 4° e 6° feira - 06:00hs - 09:00hs</p>
          <p><strong>Outros locais:</strong> Ciclismo de rua (1 vez por mês) - Vista Chinesa / Cidade Universitária</p>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "WelcomeDesktop",
  data() {
    return {
      services: [
        {
          title: "Natação no Mar",
          description: "Marcação com bóias, orientação e suporte dentro d'água com caiaque.",
          image: "@/assets/images/sport-swim.jpg"
        },
        {
          title: "Corrida",
          description: "Treinamentos técnicos com educativos, circuito na areia.",
          image: "@/assets/images/sport-run.jpg"
        },
        {
          title: "Treinamento Funcional",
          description: "Foco em fortalecimento e ganho de volume muscular.",
          image: "@/assets/images/sport-crossfit.jpg"
        },
        {
          title: "Ciclismo",
          description: "Treinos técnicos na rua e no rolo (treinamento estacionário).",
          image: "@/assets/images/tobias-bike.jpg"
        }
      ]
    };
  }
};
</script>

<style scoped>
.hero-image {
  height: 500px;
  position: relative;
}
.hero-overlay {
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
}
.subtitle {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}
.hover-card:hover {
  transform: scale(1.02);
  transition: 0.3s ease;
}
</style>
